import { memo, useCallback, useEffect, useMemo, useState } from 'react'
import { Team } from 'types/teams'
import { getTeams } from 'services/teams'
import { League } from 'types/leagues'
import { Button, Form, Select } from 'antd'
import { OptionProps } from 'antd/es/select'

type Props = {
    league: League
    onAdd: (teamId: number, leagueId: number) => void
}

export const AddTeamToLeagueForm = memo((props: Props) => {
    const { league, onAdd } = props
    const [teams, setTeams] = useState<Team[]>([])

    useEffect(() => {
        getTeams().then(setTeams)
    }, [])

    const onFinish = useCallback(
        (values: { teamId: number }) => {
            onAdd(values.teamId, league.id)
        },
        [onAdd, league]
    )

    const availableTeams = useMemo(() => {
        const addedTeams: Record<number, boolean> = league.teamsToLeagues.reduce((acc, it) => {
            acc[it.teamId] = true
            return acc
        }, {} as Record<number, boolean>)

        return teams.filter(it => !addedTeams[it.id])
    }, [league, teams])

    const teamFilterOption = useCallback((inputValue: string, option: OptionProps['option']) => {
        return !!option?.label?.toString().toLowerCase().includes(inputValue?.toLowerCase())
    }, [])

    return (
        <Form name='basic' labelCol={{ span: 8 }} wrapperCol={{ span: 16 }} onFinish={onFinish} autoComplete='off'>
            <Form.Item name='teamId' label='Team' rules={[{ required: true, message: 'Please select team!' }]}>
                <Select showSearch filterOption={teamFilterOption}>
                    {availableTeams.map(it => (
                        <Select.Option key={it.id} value={it.id} label={it.name}>
                            {it.name}
                        </Select.Option>
                    ))}
                </Select>
            </Form.Item>

            <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                <Button type='primary' htmlType='submit'>
                    Submit
                </Button>
                <Button htmlType={'reset'}>Reset</Button>
            </Form.Item>
        </Form>
    )
})
